import { IPhoto } from '@/models/products.model';
import { PhotoItem } from './configs';

export const photoToPhotoItem = (photo: IPhoto, order: number): PhotoItem => ({
  uid: photo.uuid,
  name: photo.name,
  order,
  isServerPhoto: true,
  originalUrl: photo.original_url,
});

export const fileToPhotoItem = (file: File, order: number, uid: string): PhotoItem => ({
  uid,
  name: file.name,
  order,
  isServerPhoto: false,
  originFileObj: file,
});
